import * as React from "react"

import { cn } from "src/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    (<input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props} />)
  );
})
Input.displayName = "Input"


const InputIcon = React.forwardRef(({ className, type,  ...props }, ref) => {
  return (
    <div
      className={cn(
        "flex w-full h-10 items-center rounded-md border-[1.5px] border-input bg-white pl-3 p-6 text-sm ring-offset-background focus-within:ring-1 focus-within:ring-ring focus-within:ring-offset-2",
        className,
      )}
    >
      {props.icon}
      <input
        {...props}
        type={type}
        ref={ref}
        className="w-full h-auto border-0 m-0 p-2 placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50"
      />
    </div>
  );
})
InputIcon.displayName = "InputIcon"

export { Input, InputIcon }
